<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
			<li class="breadcrumb-item"><router-link to="/sale/customers">{{ $t("customer_list") }}</router-link></li>
			<li class="breadcrumb-item active" aria-current="page">{{ $t("new") }}</li>
		</ol>
		<div class="x_header">
			<button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
				<i class="fa fa-arrow-circle-o-left"></i> {{ $t("back") }}
			</button>
			<button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave"><i class="fa fa-floppy-o"></i> {{ $t("save") }}</button>
			<button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onSave('reset')"><i class="fa fa-floppy-o"></i> {{ $t("save_and_new") }}</button>
		</div>
		<div class="x_body">
			<div class="card x_card">
				<div class="card-body">
					<div class="row">
						<div class="col-sm-6">
							<div class="flex-container">
								<div>
									<input type="file" ref="file" @change="fileChangeHandler" accept="image/*" style="display:none;"/>
									<img :src="img" alt="" class="img-thumbnail" style="width: 135px; height: 125px;" @click="$refs.file.click()">
								</div>
								<div class="flex-right">
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group">
												<label class="label-control blue">{{ $t("customer_type") }}</label>
												<div>
													<select class="form-control form-control-sm" type="text" v-model="model.CustomerTypeId">
														<option v-for="ret in types" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
													</select>
												</div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group">
												<label class="label-control blue">ប្រភេទវិក្កយបត្រ</label>
												<div>
													<select class="form-control form-control-sm" type="text" v-model="model.InvoiceType">
														<option value="COMERCIAL">COMERCIAL INVOICE</option>
														<option value="TAX">TAX INVOICE</option>
														<option value="AVDTAX">ADVANCE TAX INVOICE</option>
													</select>
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
												<label class="label-control blue">{{ $t('khmer_name')}}</label>
												<div><input class="form-control form-control-sm" type="text" v-model="$v.model.Name.$model" /></div>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="form-group" :class="{ 'form-group-error': $v.model.NameEng.$error }">
												<label class="label-control blue">{{ $t('latin_eng_name')}}</label>
												<div><input class="form-control form-control-sm" type="text" v-model="$v.model.NameEng.$model" /></div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div v-if="typeCode == 1" class="col-sm-3 form-group">
							<label class="label-control blue">ID Card Number</label>
							<b-form-input size="sm" v-model="model.VatTin"/>
						</div>
						<div v-if="typeCode != 1" class="col-sm-3 form-group">
							<label class="label-control blue">VAT TIN</label>
							<div>
								<div class="row">
									<div class="col-sm-5 col-lg-4">
										<input type="text" class="form-control form-control-sm" v-model="model.TinHead"/>
									</div>
									<div class="col-sm-7 col-lg-8">
										<b-form-input class="form-control-sm" v-model="model.VatTin"/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-6">
							<div class="form-group">
								<label class="label-control blue">{{ $t("bill_address") }}</label>
								<div>
									<input class="form-control form-control-sm" type="text" v-model="model.Address" />
								</div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-sm-2">
							<div class="form-group">
								<label class="label-control blue"> {{ $t("phone") }}</label>
								<div>
								<input class="form-control form-control-sm" type="text" v-model="model.Phone" />
								</div>
							</div>
						</div>
						<div class="col-sm-2">
							<div class="form-group">
								<label class="label-control blue">{{ $t("email") }}</label>
								<div>
									<input class="form-control form-control-sm" type="email" v-model="model.Email" />
								</div>
							</div>
						</div>
						<div class="col-sm-2">
							<div class="form-group">
								<label class="label-control blue">{{ $t("website") }}</label>
								<div>
									<input class="form-control form-control-sm" type="text" v-model="model.Website" />
								</div>
							</div>
						</div>
					</div>
					<br>
					<div class="row">
						<div class="col-sm-12">
							<nav>
								<div class="nav nav-tabs" id="nav-tab" role="tablist">
									<a class="nav-link" :class="{active: tabIndex==1}" href="javascript:void(0)" @click="tabIndex=1">{{$t('shipping_delivery_address')}}</a>
									<a class="nav-link" :class="{active: tabIndex==2}" href="javascript:void(0)" @click="tabIndex=2">{{$t('accounting')}}</a>
									<a class="nav-link" :class="{active: tabIndex==3}" href="javascript:void(0)" @click="tabIndex=3">{{$t('product_or_service')}}</a>
								</div>
							</nav>
							<div class="tab-content" id="nav-tabContent">
								<div class="tab-pane fade" :class="{'show active': tabIndex==1}">
									<div class="row">
										<div class="col-sm-6">
											<div style="padding: 15px 0; display: flex; gap: 5px;">
												<button type="button" class="btn btn-outline-success btn-sm" @click="addNewAddress"><i class="fa fa-plus" aria-hidden="true"></i> {{$t('add_new')}}</button>
												<button v-if="isCheck" class="btn btn-outline-danger btn-sm" @click="removeAddress"><i class="fa fa-times" aria-hidden="true"></i> {{$t('remove')}}</button>
											</div>
											<div class="row">
												<div class="col-sm-12">
													<table class="table table-bordered table-sm no-bor">
														<thead>
															<tr>
																<th class="text-center" style="width: 30px;"><input type="checkbox" v-model="isCheckAll"/></th>
																<th class="text-center" style="width: 50px;">{{$t('no')}}</th>
																<th>{{$t('name')}}</th>
																<th>{{$t('contact')}}</th>
																<th>{{$t('phone')}}</th>
																<th>{{$t('address')}}</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="(ret,index) in addresses" :key="index">
																<td class="text-center"><input type="checkbox" v-model="ret.Checked" /></td>
																<td class="text-center">{{index+1}}</td>
																<td><a href="javascript:void(0)" @click="editAddress(ret, index)">{{ret.Name}}</a></td>
																<td>{{ret.ContactName}}</td>
																<td>{{ret.ContactPhone}}</td>
																<td>{{ret.Address}}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="tab-pane fade" :class="{'show active': tabIndex==2}">
									<div class="row">
										<div class="col-sm-3">
											<div class="form-group">
												<label class="label-control blue">{{ $t("paid_to_bank") }}</label>
												<div>
													<select class="form-control form-control-sm" v-model="model.BankId">
														<option v-for="ret in banks" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
													</select>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="tab-pane fade" :class="{'show active': tabIndex==3}">
									<div class="row">
										<div class="col-sm-6">
											<div style="padding: 15px 0; display: flex; gap: 5px;">
												<button type="button" class="btn btn-outline-success btn-sm" @click="addNewItem"><i class="fa fa-plus" aria-hidden="true"></i> {{$t('add_new')}}</button>
												<button v-if="isItemChecked" class="btn btn-outline-danger btn-sm" @click="removeItem"><i class="fa fa-times" aria-hidden="true"></i> {{$t('remove')}}</button>
											</div>
											<div class="row">
												<div class="col-sm-12">
													<table class="table table-bordered table-sm no-bor">
														<thead>
															<tr>
																<th class="text-center" style="width: 30px;"><input type="checkbox" v-model="allItemChecked"/></th>
																<th>{{$t('code')}}</th>
																<th>{{$t('name')}}</th>
																<th>{{$t('uom')}}</th>
																<th>{{$t('barcode')}}</th>
															</tr>
														</thead>
														<tbody>
															<tr v-for="(ret,index) in items" :key="index">
																<td class="text-center">
																	<input type="checkbox" v-model="ret.Checked" />
																</td>
																<td>{{ret.ItemNum}}</td>
																<td>{{ret.ItemName}}</td>
																<td>{{ret.UomName}}</td>
																<td class="cell-input"><input type="text" class="form-control form-control-sm" v-model="ret.Barcode"/></td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal v-model="addressIndex" :title="$t('address')" modal-class="modal-x" size="sm" :no-close-on-backdrop="true">
			<div class="form-group" :class="{ 'form-group-error': $v.address.Name.$error }">
				<label class="label-control blue">{{ $t("name") }}</label>
				<div>
					<input type="text" class="form-control form-control-sm" v-model="$v.address.Name.$model"/>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6">
					<div class="form-group">
						<label class="label-control blue">{{ $t("contact") }}</label>
						<div>
							<input type="text" class="form-control form-control-sm" v-model="address.ContactName"/>
						</div>
					</div>
				</div>
				<div class="col-sm-6">
					<div class="form-group">
						<label class="label-control blue">{{ $t("phone") }}</label>
						<div>
							<input type="text" class="form-control form-control-sm" v-model="address.ContactPhone"/>
						</div>
					</div>
				</div>
			</div>
			<div class="form-group">
				<label class="label-control blue">{{ $t("address") }}</label>
				<div>
					<textarea class="form-control form-control-sm" v-model="address.Address"></textarea>
				</div>
			</div>
			<div slot="modal-footer">
                <button type="button" class="btn btn-outline-success btn-sm" @click="addAddress"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
            </div>
		</b-modal>
		<ItemSelectMultipleModal ref="itemSelect" @selected="itemSelected"></ItemSelectMultipleModal>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import Swal from "sweetalert2";
import { ItemSelectMultipleModal } from '../Item';
export default {
	components: { ItemSelectMultipleModal },
	data: function () {
		return {
			model: {
				InvoiceType: 'COMERCIAL',
				CustomerTypeId: '',
				Name: "",
				Phone: "",
				NameEng: ""
			},
			actionLink: "customer/save",
			types: [],
			img: '/img/no-image.svg',
			formHead: {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			},
			tabIndex: 1,
			isCheckAll: false,
			addressIndex: false,
			editIndex: -1,
			address: {
				Checked: false,
				Name: ''
			},
			allItemChecked: false,			
			isShowItem: false,
			items: [],
			addresses: [],
			banks: []
		}
	},
	validations:{
		model: {
			Name: { required },
			NameEng: { required }
		},
		address: {
			Name: { required }
		}
	},
	async created(){
		await this.initForm();
	},
	methods: {
		async initForm(){
			var req = {
				CompanyId: this.$store.state.company.Id
			};
			let id = this.$route.params.id;
			if (!this.$isEmpty(id)) {
				req.Id = id;
				this.actionLink = 'customer/update';
			}
			var res = await this.$api().post('customer/init-form', req);
			if(this.$isValid(res)){
				let json = res.data.Json;
				this.types = json.Types;
				this.banks = json.Banks;
				if(!this.$isEmpty(id)){
					this.model = json.Customer;
					this.addresses = json.Addresses;
					this.items = json.CustomerPrices;
					if(!this.$isEmpty(this.model.Image)){
						this.img = this.$base() + 'image/image/' + this.model.Image;
					}
				}else{
					if(this.types.length > 0)
						this.model.CustomerTypeId = this.types[0].Id;
				}
			}
		},
		onSave (par) {
			this.$v.model.$touch();
			if(!this.$v.model.$invalid) {
				let loading = this.$loading.show();
				let formData = new FormData();
				formData.append('File', this.$refs.file.files[0]);
				for (let p in this.model) {
					let val = this.model[p];
					if(val != null)
						formData.append(p, val);
				}
				formData.append('CustomerAddresses', JSON.stringify(this.addresses));
                formData.append('CustomerPrices', JSON.stringify(this.items));
                formData.append('CompanyId', this.$store.state.company.Id);
                formData.append('ClientId', this.$store.state.company.ClientId);
				this.$api().post(this.actionLink, formData, this.formHead).then((res) => {
					if (this.$isValid(res)) {
						Swal.fire('Success', 'The customer save success.', 'success');
						if(par == 'reset') {
							this.model.InvoiceType = 'COMERCIAL';
							this.model.CustomerTypeId = '';
							this.model.Name = "";
							this.model.Phone = "";
							this.model.NameEng = "";
							this.$v.$reset();
						} else {
							this.$router.push("/sale/customers");
						}
					}
				}).finally(function () { loading.hide(); });
			}
		},
		fileChangeHandler: function(e){
			const file = e.target.files[0];
			this.img = URL.createObjectURL(file);
		},
		addNewAddress(){
			this.address = {
				Checked: false,
				Name: ''
			};
			this.$v.address.$reset();
			this.editIndex = -1;
			this.addressIndex = true;
		},
		addAddress(){
			this.$v.address.$touch();
			if(!this.$v.address.$invalid){
				if(this.editIndex == -1){
					this.addresses.push(this.address);
				}else{
					this.addresses[this.editIndex] = this.address;
				}
				this.addressIndex = false;
			}
		},
		editAddress(item, index){
			this.editIndex = index;
			this.address = JSON.parse(JSON.stringify(item));
			this.addressIndex = true;
		},
		removeAddress(){
			this.addresses = this.addresses.filter(el => el.Checked == false);
		},
		addNewItem(){
			this.$refs.itemSelect.$refs.innermodal.show();
		},
		itemSelected(e){
			this.$refs.itemSelect.$refs.innermodal.hide();
			let res = this.items.filter(el => el.ItemId == e.Id);
			if(res.length == 0){
				this.items.push({
					Checked: false,
					ItemId: e.Id,
					ItemNum: e.Num,
					ItemName: e.Name,
					UomName: e.UomName,
					Barcode: ''
				});
			}
		},
		removeItem(){
			this.items = this.items.filter(el => el.Checked == false);
		}
	},
	computed: {
		isCheck(){
			let res = this.addresses.filter(el => el.Checked == true);
			if(res != null && res.length > 0) return true;
			return false;
		},
		isItemChecked(){
			let res = this.items.filter(el => el.Checked == true);
			if(res != null && res.length > 0) return true;
			return false;
		},
		typeCode(){
			let find = this.types.find(el => el.Id == this.model.CustomerTypeId);
			return find != undefined?find.Code:1;
		}
	},
	watch: {
		isCheckAll(value){
			this.addresses.forEach(element => {
				element.Checked = value;
			});
		},
		allItemChecked(value){
			this.items.forEach(element => {
				element.Checked = value;
			});
		}
	}
};
</script>
<style scoped>
	.nav-link.active{
		color: #0856ab;
	}
</style>
